"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getInlineFragment;
const nullThrows_1 = __importDefault(require("./nullThrows"));
function getInlineFragment(fragmentDefinitions, fragment) {
    return fragment.type === "InlineFragment"
        ? fragment
        : (0, nullThrows_1.default)(fragmentDefinitions[fragment.fragmentName], `Missing fragment definition for fragment with name: "${fragment.fragmentName}".`);
}
//# sourceMappingURL=getInlineFragment.js.map